export const BASE_SP_V2_PATH = "#StudyPlan.study_plan_v2"

export const BASE_SP_V2_PROGRESS_PATH =
  "#StudyPlan.study_plan_v2.sp_v2_progress_state"

export const BASE_SP_V2_SETTINGS_PATH =
  "#StudyPlan.study_plan_v2.sp_v2_settings_state"

export const BASE_SP_V2_PROGRESS_BY_CONTENT_PATH =
  "#StudyPlan.study_plan_v2.sp_v2_progress_by_content_state"

export const BASE_STUDY_PLAN_V2_ADMIN_MANAGE_PATH =
  "#StudyPlan.study_plan_v2.sp_v2_admin_manage_study_plans_state"

export const BASE_STUDY_PLAN_V2_TEACHER_MANAGE_PATH =
  "#StudyPlan.study_plan_v2.sp_v2_teacher_manage_study_plans_state"

export const BASE_SP_V2_PROGRESS_BY_STUDENT_PATH =
  "#StudyPlan.study_plan_v2.sp_v2_progress_by_student_state"

export const BASE_SP_V2_TEACHER_OVERALL_PATH =
  "#StudyPlan.study_plan_v2.sp_v2_teacher_overall_state"
